import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  DatePicker,
  Flex,
  Input,
  notification,
  PaginationProps,
  Table,
  TableColumnsType,
} from "antd";
import {
  Calendar2,
  DocumentDownload,
  ExportSquare,
  Home2,
  SearchZoomIn1,
  Warning2,
} from "iconsax-react";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  LineOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import "./staff.scss";
import { mixPostV1 } from "../../services/mixin";
// @ts-ignore
import * as XLSX from "xlsx-js-style";
import type { Dayjs } from "dayjs";
import EditStaffReportInfoPopup from "./Components/EditStaffReportInfoPopup";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";
import ExtraView from "./Components/ExtraView";
import BonusDetailView from "./Components/BonusDetailView";
import { ExportReportStaff } from "../../components/Interface/InterfaceTemp";

const { RangePicker } = DatePicker;

const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  // Can not select days before today and today
  return current && current > dayjs().endOf("day");
};

const numberFormat = (number: any) => {
  let result;
  if (typeof number === "number") {
    result = new Intl.NumberFormat().format(number);
  } else {
    result = number;
  }
  return result;
};

interface DataType {
  key: React.Key;
  date: string;
  staff: string;
  staff_warning: boolean;
  start: number;
  add_bank: number;
  match: number;
  payout: number;
  bonus: number;
  extra: number;
  proof: number;
  final: number;
}

export const pencil = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {" "}
    <g clipPath="url(#clip0_1265_4186)">
      {" "}
      <path
        d="M14.167 2.49993C14.3859 2.28106 14.6457 2.10744 14.9317 1.98899C15.2176 1.87054 15.5241 1.80957 15.8337 1.80957C16.1432 1.80957 16.4497 1.87054 16.7357 1.98899C17.0216 2.10744 17.2815 2.28106 17.5003 2.49993C17.7192 2.7188 17.8928 2.97863 18.0113 3.2646C18.1297 3.55057 18.1907 3.85706 18.1907 4.16659C18.1907 4.47612 18.1297 4.78262 18.0113 5.06859C17.8928 5.35455 17.7192 5.61439 17.5003 5.83326L6.25033 17.0833L1.66699 18.3333L2.91699 13.7499L14.167 2.49993Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />{" "}
    </g>{" "}
    <defs>
      {" "}
      <clipPath id="clip0_1265_4186">
        {" "}
        <rect width="20" height="20" fill="white" />{" "}
      </clipPath>{" "}
    </defs>{" "}
  </svg>
);

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const ReportStaff: React.FC = () => {
  const navigate = useNavigate();
  const view_staff_report = localStorage.getItem("view_staff_report") ?? "0";
  const [selectedItem, setSelectedItem] = useState({} as any);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [isShow, SetIsShow] = useState(false);
  const [dataView, SetDataView] = useState(false);
  const [isShowBonus, setIsShowBonus] = useState(false);
  const [dataViewBonus, setDataViewBonus] = useState<any>(null);
  const [exportingId, setExportingId] = useState<number | null>(null);
  const columns: TableColumnsType<DataType> = [
    {
      title: "",
      key: "actions",
      fixed: "left",
      className: "actions-sticky actions-sticky--left",
      render: (text, record) => (
        <Flex align="center" gap={4}>
          <Button
            icon={pencil}
            className="rs-button edit"
            onClick={() => {
              setSelectedItem(record);
              setShowEditPopup(true);
            }}
          />
          <Button
            icon={<DocumentDownload />}
            className="rs-button edit"
            loading={exportingId === Number(record.key)}
            onClick={() => exportDataReport(Number(record.key))}
          />
        </Flex>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Staff",
      dataIndex: "staff",
      key: "staff",
      render: (text, record) => (
        <Flex align="center" gap={8}>
          <span>{text}</span>
          {/* {
            record.proof !== record.final && <Warning2 size="20" variant="Bulk" className='text-active'/>
          } */}
        </Flex>
      ),
    },
    {
      title: "Start",
      dataIndex: "start",
      key: "start",
      render: (text, record) => (
        <Flex vertical gap={4}>
          <span className="text-light">{numberFormat(text)}</span>
          <span className="text-red-3 title-12">
            Add bank&nbsp;{numberFormat(record.add_bank)}
          </span>
        </Flex>
      ),
    },
    {
      title: "Match",
      dataIndex: "match",
      key: "match",
      align: "right",
      render: (text) => (
        <span className="text-light">{numberFormat(text)}</span>
      ),
    },
    {
      title: "Pay out",
      dataIndex: "payout",
      key: "payout",
      align: "right",
      render: (text) => (
        <span className="text-light">{numberFormat(text)}</span>
      ),
    },
    {
      title: "Bonus",
      dataIndex: "bonus",
      key: "bonus",
      align: "right",
      render: (text, record: any) => (
        <span
          style={{ borderBottom: "1px solid", cursor: "pointer" }}
          className="text-light"
          onClick={() => {
            setIsShowBonus(true);
            setDataViewBonus(record);
          }}
        >
          {numberFormat(text)} <EyeOutlined />
        </span>
      ),
    },
    {
      title: "Extra",
      dataIndex: "extra",
      key: "extra",
      align: "right",
      render: (text, record: any) => (
        <span
          style={{ borderBottom: "1px solid", cursor: "pointer" }}
          className="text-light"
          onClick={() => {
            SetIsShow(true);
            SetDataView(record);
          }}
        >
          {numberFormat(text)} <EyeOutlined />
        </span>
      ),
    },
    {
      title: "Cash on hand",
      dataIndex: "proof",
      key: "proof",
      align: "right",
      render: (text) => (
        <span className="text-light">{numberFormat(text)}</span>
      ),
    },
    // {
    //   title: 'Final',
    //   dataIndex: 'final',
    //   key: 'final',
    //   align: 'right',
    //   render: (text) => (
    //     <span className='text-light'>{numberFormat(text)}</span>
    //   )
    // },
  ];

  // GET LIST
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchKey?: string;
    date_start?: string;
    date_end?: string;
  }>({
    limit: 10,
    page_number: 1,
  });

  const exportDataReport = async (info_id: number) => {
    setExportingId(info_id);
    try {
      const res = await mixPostV1(
        "/api/webAdmin/export_gDetailReportStaff.php",
        {
          info_id,
        },
      );

      if (res.status === 1 && res.data) {
        const data: ExportReportStaff = res.data;
        const infoReport = data.infoReport as any;

        // Resolve store name
        const stores = JSON.parse(localStorage.getItem("stores") || "[]");
        const storeId = localStorage.getItem("storeId") || "";
        const currentStore = stores.find(
          (s: any) => s.key === storeId || s.store_id?.toString() === storeId,
        );
        const storeName = currentStore
          ? currentStore.store_name || currentStore.label
          : "";

        // Formatted Date
        const dateDownload = dayjs().format("MM/DD/YYYY");

        // Helper to format values
        const sumBank = Number(infoReport.start_amount) || 0;
        const sumMatch = Number(infoReport.match_total) || 0;
        const sumPayout = Number(infoReport.payout_total) || 0;
        const sumBonus = Number(infoReport.bonus_amount) || 0;
        const sumCashOnHand = Number(infoReport.money_proof) || 0;

        // Construct sheetData (Rows 0 to 5)
        const sheetData: any[][] = [
          [
            "Store Name",
            infoReport.store_name || storeName || "",
            "",
            "",
            "Bank",
            sumBank,
          ],
          [
            "Date",
            infoReport.dateExport || dateDownload,
            "",
            "",
            "Match",
            sumMatch,
          ],
          [
            "Employee",
            infoReport.staff_name || "",
            "",
            "",
            "Pay out",
            sumPayout,
          ],
          [
            "Session",
            infoReport.shift
              ? `Shift ${infoReport.shift} - ${infoReport.date_report}`
              : infoReport.date_report || "",
            "",
            "",
            "Bonus",
            sumBonus,
          ],
          ["", "", "", "", "Cash on hand", sumCashOnHand],
          [], // Row 5 blank spacer
          // Row 6 (Table titles)
          [
            "Match Report",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Bonus",
            "",
            "",
            "",
            "Extra",
            "",
          ],
          // Row 7 (Table headers)
          [
            "#",
            "Customer id",
            "Customer name",
            "Match",
            "Machine",
            "Time",
            "Checkin by",
            "",
            "Time",
            "Machine",
            "Cash out",
            "",
            "Detail",
            "Extra (USD)",
          ],
        ];

        const listMatch = data.listMatch || [];
        const listBonus = data.listBonus || [];
        const listExtra = data.listExtra || [];

        const matchRowCount = listMatch.length + 1;
        const bonusRowCount = listBonus.length + 1;
        const extraRowCount = listExtra.length + 1;

        const maxRows = Math.max(matchRowCount, bonusRowCount, extraRowCount);

        for (let i = 0; i < maxRows; i++) {
          const row = Array(14).fill("");

          // Match Report column (index 0 to 6)
          if (i < listMatch.length) {
            const m = listMatch[i];
            row[0] = i + 1;
            row[1] = m.customer_id;
            row[2] = m.customer_name;
            row[3] = Number(m.match_amount) || 0;
            row[4] = m.machine_number || "";
            row[5] = m.time_match;
            row[6] = m.checkin_by;
          } else if (i === listMatch.length) {
            row[0] = `Match Total: ${numberFormat(sumMatch)}`;
          }

          // Bonus column (index 8 to 10)
          if (i < listBonus.length) {
            const b = listBonus[i];
            row[8] = b.time_bonus;
            row[9] = b.machine_number;
            row[10] = Number(b.cash_out_amount) || 0;
          } else if (i === listBonus.length) {
            row[8] = `Bonus Total: ${numberFormat(sumBonus)}`;
          }

          // Extra column (index 12 to 13)
          if (i < listExtra.length) {
            const ext = listExtra[i];
            row[12] = ext.cost_category;
            row[13] = Number(ext.amount) || 0;
          } else if (i === listExtra.length) {
            row[12] = `Extra Total: ${numberFormat(infoReport.extra_amount || 0)}`;
          }

          sheetData.push(row);
        }

        const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);

        // Merges configurations
        const merges: any[] = [
          // Table titles
          { s: { r: 6, c: 0 }, e: { r: 6, c: 6 } }, // Match Report
          { s: { r: 6, c: 8 }, e: { r: 6, c: 10 } }, // Bonus
          { s: { r: 6, c: 12 }, e: { r: 6, c: 13 } }, // Extra
        ];

        // Total Row Merges
        const matchTotalRowIdx = 8 + listMatch.length;
        merges.push({
          s: { r: matchTotalRowIdx, c: 0 },
          e: { r: matchTotalRowIdx, c: 6 },
        });

        const bonusTotalRowIdx = 8 + listBonus.length;
        merges.push({
          s: { r: bonusTotalRowIdx, c: 8 },
          e: { r: bonusTotalRowIdx, c: 10 },
        });

        const extraTotalRowIdx = 8 + listExtra.length;
        merges.push({
          s: { r: extraTotalRowIdx, c: 12 },
          e: { r: extraTotalRowIdx, c: 13 },
        });

        worksheet["!merges"] = merges;

        // Columns widths configuration
        const wscols = [
          { wch: 6 }, // # (Col A)
          { wch: 15 }, // Customer id (Col B)
          { wch: 20 }, // Customer name (Col C)
          { wch: 12 }, // Match (Col D)
          { wch: 12 }, // Machine (Col E)
          { wch: 20 }, // Time (Col F)
          { wch: 18 }, // Checkin by (Col G)
          { wch: 4 }, // spacer (Col H)
          { wch: 20 }, // Time (Col I)
          { wch: 12 }, // Machine (Col J)
          { wch: 12 }, // Cash out (Col K)
          { wch: 4 }, // spacer (Col L)
          { wch: 18 }, // Detail (Col M)
          { wch: 15 }, // Extra (USD) (Col N)
        ];
        worksheet["!cols"] = wscols;

        // Apply formatting & styles to Metadata Block 1 (A1:B4 -> Rows 0-3, Cols 0-1)
        for (let r = 0; r <= 3; r++) {
          for (let c = 0; c <= 1; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              font: c === 0 ? { bold: true } : undefined,
              alignment: { vertical: "center" },
            };
          }
        }

        // Apply formatting & styles to Metadata Block 2 (E1:F5 -> Rows 0-4, Cols 4-5)
        for (let r = 0; r <= 4; r++) {
          for (let c = 4; c <= 5; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              font: c === 4 ? { bold: true } : undefined,
              alignment: { vertical: "center" },
            };
          }
        }

        // Apply styles to Match Report Table
        for (let r = 6; r <= matchTotalRowIdx; r++) {
          for (let c = 0; c <= 6; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            const isTitle = r === 6;
            const isHeader = r === 7;
            const isTotal = r === matchTotalRowIdx;
            let cellAlign: any = undefined;
            if (isTitle || isHeader || isTotal) {
              cellAlign = { horizontal: "center", vertical: "center" };
            } else if (c === 3) {
              cellAlign = { horizontal: "right", vertical: "center" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: cellAlign,
              font: isTitle
                ? { bold: true, sz: 12 }
                : isHeader || isTotal
                  ? { bold: true }
                  : undefined,
            };
          }
        }

        // Apply styles to Bonus Table
        for (let r = 6; r <= bonusTotalRowIdx; r++) {
          for (let c = 8; c <= 10; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            const isTitle = r === 6;
            const isHeader = r === 7;
            const isTotal = r === bonusTotalRowIdx;
            let cellAlign: any = undefined;
            if (isTitle || isHeader || isTotal) {
              cellAlign = { horizontal: "center", vertical: "center" };
            } else if (c === 10) {
              cellAlign = { horizontal: "right", vertical: "center" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: cellAlign,
              font: isTitle
                ? { bold: true, sz: 12 }
                : isHeader || isTotal
                  ? { bold: true }
                  : undefined,
            };
          }
        }

        // Apply styles to Extra Table
        for (let r = 6; r <= extraTotalRowIdx; r++) {
          for (let c = 12; c <= 13; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            const isTitle = r === 6;
            const isHeader = r === 7;
            const isTotal = r === extraTotalRowIdx;
            let cellAlign: any = undefined;
            if (isTitle || isHeader || isTotal) {
              cellAlign = { horizontal: "center", vertical: "center" };
            } else if (c === 13) {
              cellAlign = { horizontal: "right", vertical: "center" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: cellAlign,
              font: isTitle
                ? { bold: true, sz: 12 }
                : isHeader || isTotal
                  ? { bold: true }
                  : undefined,
            };
          }
        }

        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "Staff Detail Report",
        );

        const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "buffer",
        });

        const dataBlob: Blob = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(dataBlob);
        const filename = `Staff_Report_${infoReport.staff_name || "Detail"}_${infoReport.date_report || dayjs().format("YYYYMMDD")}.xlsx`;
        link.download = filename;
        link.click();

        openNotification("success", "Export detail report successful!");
      } else {
        openNotification("error", res?.message || "No data returned!");
      }
    } catch (error) {
      console.error("Error exporting Excel:", error);
      openNotification("error", "Oops, something went wrong during export!");
    } finally {
      setExportingId(null);
    }
  };

  const getItems = async () => {
    setTableLoading(true);
    const res = await mixPostV1("/api/webAdmin/gReportStaffByDate.php", params);

    if (res.status === 1) {
      const result: any = [];
      res.data.map((item: any) =>
        result.push({
          ...item,
          key: item.info_id,
          date: item.date_report,
          staff: item.staff_name,
          start: item.start_amount,
          add_bank: item.addbank,
          match: item.match_total,
          payout: item.payout_total,
          bonus: item.bonus_amount,
          extra: item.extra_amount,
          proof: item.money_proof,
          final: item.final,
        }),
      );
      setItems({
        ...items,
        list: result,
        total: res.total,
      });
      setTableLoading(false);
    }
  };

  useEffect(() => {
    if (Number(view_staff_report) === 0) {
      navigate("/");
    }
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  // END GET LIST

  // SEARCH
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const onSearch = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      searchKey: query,
    });
  };
  const onEnter = (e: any) => {
    onSearch(e.target.value);
  };
  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };

  // On Date Change
  const onRangeChange = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[],
  ) => {
    if (dates) {
      setParams({
        ...params,
        page_number: 1,
        date_start: dateStrings[0],
        date_end: dateStrings[1],
      });
    } else {
      setParams({
        ...params,
        page_number: 1,
        date_start: "",
        date_end: "",
      });
    }
  };
  // END SEARCH

  // EXPORT EXCEL
  const getItemsByExcel = async () => {
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
    };

    try {
      const res = await mixPostV1(
        "/api/webAdmin/gReportStaffByDate.php",
        customParams,
      );

      if (res.status) {
        if (res.data.length > 0) {
          formattedDataExcel(res.data);
        } else {
          openNotification("error", "There is no data to export!");
        }
      } else {
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
    }
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        Date: item.date_report,
        Staff: item.staff_name,
        Start: item.start_amount,
        "Add Bank": item.addbank,
        Match: item.match_total,
        Payout: item.payout_total,
        Bonus: item.bonus_amount,
        Extra: item.extra_amount,
        "Cash on hand": item.money_proof,
        Final: item.final,
      };
    });
    exportExcel(formattedData);
  };
  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"Staff Report"}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };
  // END EXPORT EXCEL

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Request success!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  return (
    <>
      {contextHolder}

      <Layout contentClassName="report-staff-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Report" },
            { title: "Staff" },
          ]}
          title="Staff"
          description=""
        />

        <div className="table-filter-block">
          <Input
            placeholder="Search by name"
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            className="rs-input filter-search-box1 table-filter-block__search"
            allowClear
            onPressEnter={(e) => onEnter(e)}
            onChange={(e) => onChange(e)}
          />

          <RangePicker
            allowClear
            className="rs-range-picker"
            suffixIcon={<Calendar2 size={20} />}
            separator={<LineOutlined />}
            placeholder={["From date", "To date"]}
            disabledDate={disabledDate}
            onChange={onRangeChange}
          />

          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button mis-auto"
            onClick={getItemsByExcel}
          >
            Export
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={items.list}
          className="rs-table table-text-nowrap match-height"
          loading={tableLoading}
          scroll={{
            x: true,
          }}
          pagination={{
            current: params.page_number,
            pageSize: params.limit,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            total: items.total,
            itemRender: customPrevNext,
            onChange: (e) => onPageChange(e),
          }}
          onChange={onTableChange}
        />
      </Layout>

      <EditStaffReportInfoPopup
        isShow={showEditPopup}
        item={selectedItem}
        onPopupClose={() => setShowEditPopup(false)}
        onSuccess={getItems}
      />
      <ExtraView
        isShow={isShow}
        dataView={dataView}
        onPopupClose={() => SetIsShow(false)}
      />
      <BonusDetailView
        isShow={isShowBonus}
        dataView={dataViewBonus}
        onPopupClose={() => setIsShowBonus(false)}
      />
    </>
  );
};

export default ReportStaff;
